export default __webpack_public_path__ + "static/media/BodoniModa_6pt-SemiBold.12b7f2b1.ttf";